import React from 'react';
import MainProjectCard from './MainProjectCard';
import { Flex, Heading, useColorModeValue } from '@chakra-ui/react';
import AnimatedPage from './Other/AnimatedPage';
import parcels4 from '../Images/parcelsimages/4.jfif';
import angularParcels from '../Images/angularParcelsImages/2.JPG';

const MainProjectsPage = () => {
  const underlineColor = useColorModeValue(
    'rgb(64,64,64,0.6)',
    'rgb(255,255,255,0.6)'
  );

  return (
    <AnimatedPage>
      <Flex
        minH={'66vh'}
        my={'2rem'}
        direction={'column'}
        alignItems={'center'}
      >
        <Heading
          size={'2xl'}
          w={'100%'}
          borderBottom={`1px solid ${underlineColor}`}
          pb={'15px'}
          mb={'20px'}
          textAlign={['center', 'center', 'center', 'start', 'start', 'start']}
        >
          Main Projects
        </Heading>
        <Flex
          direction={['column', 'column', 'column', 'row', 'row', 'row']}
          justifyContent={[
            null,
            null,
            null,
            'space-evenly',
            'space-evenly',
            'space-evenly',
          ]}
          alignItems={['center', 'center', 'center', null, null, null]}
        >
          <MainProjectCard
            route="/main_projects/7"
            title={'Parcels Management App V2.0'}
            description={
              'Upgraded version of the first parcels management app, done in Angular'
            }
            image={angularParcels}
          />
          <MainProjectCard
            route="/main_projects/6"
            title={'Parcels Management App'}
            description={
              'An app to manage Parcels for stores and companies that are used to serve as a delivery location, done in reactjs'
            }
            image={parcels4}
          />
        </Flex>
      </Flex>
    </AnimatedPage>
  );
};

export default MainProjectsPage;
